export const knownDevTabDetails = [
    {
      id: 1,
      name: 'Development Property Info',
      isOpen: true
    },
    {
      id: 2,
      name: 'Ownership Info',
      isOpen: false
    },  
    {
      id: 3,
      name: 'Contractor Info',
      isOpen: false
    },
    {
      id: 4,
      name: 'Operator/Management Info',
      isOpen: false
    },
    {
      id: 5,
      name: 'Document Center',
      isOpen: false
    }
  ]
  export const  newhousingpin =
    {
      newhousing :13
    }
